import { render, staticRenderFns } from "./confirmar.vue?vue&type=template&id=3d0460c3&scoped=true"
import script from "./confirmar.vue?vue&type=script&lang=js"
export * from "./confirmar.vue?vue&type=script&lang=js"
import style0 from "./confirmar.vue?vue&type=style&index=0&id=3d0460c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0460c3",
  null
  
)

export default component.exports